import { LightSourcePartEntity, LightSourcePartDto } from '../interfaces';
import { Core } from '../../core';

export const LightSourcePartsStore = Core.Stores.create<LightSourcePartEntity, LightSourcePartDto>(
  '/parts/light-sources',
);
